import { Star } from "lucide-react";

const stats = [
  { value: "500+", label: "Active Members" },
  { value: "4.9", label: "Average Rating", icon: true },
  { value: "15min", label: "Avg. Response Time" },
  { value: "98%", label: "Retention Rate" },
];

const testimonials = [
  {
    name: "Marcus T.",
    role: "Tech Executive",
    text: "LUXGROOM changed my mornings. A fresh fade before my 9am standup, right at my door. I haven't been to a shop in a year.",
    rating: 5,
  },
  {
    name: "Devon R.",
    role: "Professional Athlete",
    text: "After practice, the last thing I want is to sit in a barber chair for hours. LUXGROOM gets me right at home in 30 minutes.",
    rating: 5,
  },
  {
    name: "James K.",
    role: "Startup Founder",
    text: "The membership pays for itself in time saved alone. Consistent quality every single week. Game changer.",
    rating: 5,
  },
];

export default function SocialProof() {
  return (
    <section data-testid="social-proof-section" className="relative py-24 md:py-32 bg-[#0A0A0B]">
      <div className="px-6 md:px-12 lg:px-24">
        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-20">
          {stats.map((stat, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="text-center p-6 rounded-md bg-[#141416] border border-white/5"
            >
              <div className="flex items-center justify-center gap-2 mb-2">
                <span className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-[#F3F4F6]">
                  {stat.value}
                </span>
                {stat.icon && <Star className="w-5 h-5 text-[#C5A059] fill-[#C5A059]" />}
              </div>
              <span className="text-sm text-[#71717A] uppercase tracking-[0.15em]">
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* Section header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-[#C5A059]" />
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C5A059]">
              Testimonials
            </span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-[#F3F4F6]">
            Trusted by top professionals
          </h2>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="p-8 rounded-md bg-[#141416] border border-white/5 hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 text-[#C5A059] fill-[#C5A059]" />
                ))}
              </div>
              <p className="text-[#A1A1AA] text-base leading-relaxed font-light mb-6">
                "{t.text}"
              </p>
              <div>
                <p className="text-[#F3F4F6] font-medium text-sm">{t.name}</p>
                <p className="text-[#71717A] text-xs">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="section-divider mt-24 mx-6 md:mx-12 lg:mx-24" />
    </section>
  );
}
